// Policy Components - Barrel exports
export { SuspendPolicyDialog, ReactivatePolicyDialog } from './SuspendPolicyDialog';
export { RenewalPolicyDialog } from './RenewalPolicyDialog';

// Policy type constants
// 29/09/2026 — aggiunto "cvt" = Corpi Veicoli Terrestri (kasko/danni al mezzo).
// Questa e' la lista CANONICA del frontend: l'import (PolicyDataCard), il
// modulo "crea polizza" (PoliciesPage), i filtri e i badge leggono da qui.
export const POLICY_TYPES = [
  { value: "auto", label: "Auto", icon: "🚗" },
  { value: "moto", label: "Moto", icon: "🏍️" },
  { value: "autocarri", label: "Autocarri", icon: "🚚" },
  { value: "altri_veicoli", label: "Altri Veicoli", icon: "🚐" },
  { value: "targa_prova", label: "Targa Prova", icon: "🔧" },
  { value: "cvt", label: "CVT", icon: "🛡️" },
  { value: "casa", label: "Casa", icon: "🏠" },
  { value: "vita", label: "Vita", icon: "❤️" },
  { value: "salute", label: "Salute", icon: "🏥" },
  { value: "rc_professionale", label: "RC Professionale", icon: "💼" },
  { value: "rct", label: "RCT", icon: "🏢" },
  { value: "vettoriale", label: "Vettoriale", icon: "📦" },
  { value: "infortuni", label: "Infortuni", icon: "🤕" },
  { value: "condominio", label: "RC Condominio", icon: "🏘️" },
  { value: "rc_caccia", label: "RC Caccia", icon: "🏹" },
  { value: "altro", label: "Altro", icon: "📄" },
];

// Rami veicolo sospendibili (allineato a policies.py / TIPI_POLIZZA_VEICOLO).
export const SUSPENDABLE_TYPES = ["auto", "moto", "autocarri", "altri_veicoli", "targa_prova", "cvt"];

// Rami VEICOLO (con targa): decide la cartella documenti Polizze/{TARGA}.
// DEBITO TECNICO: e' un mirror della lista backend
// services/regole_polizza.TIPI_POLIZZA_VEICOLO (JS e Python non condividono il
// codice). Se si aggiunge un tipo veicolo, va aggiornato in ENTRAMBI i posti.
export const VEHICLE_TYPES = [
  "auto", "moto", "autocarri", "autocarro", "altri_veicoli",
  "vettoriale", "ciclomotore", "motociclo", "motocicli",
  "autoveicolo", "autoveicoli", "autovettura", "autovetture",
  "automezzo", "automezzi", "semirimorchio", "semirimorchi",
  "rimorchio", "rimorchi", "targa_prova", "targa prova",
  "cvt", "corpi_veicoli_terrestri",
];

export const isVehiclePolicyType = (value) =>
  VEHICLE_TYPES.includes(String(value ?? "").trim().toLowerCase());

export const NOT_RENEWED_REASONS = [
  { value: "price", label: "Prezzo troppo alto" },
  { value: "competitor", label: "Passato alla concorrenza" },
  { value: "sold_vehicle", label: "Veicolo venduto" },
  { value: "no_need", label: "Non necessita più copertura" },
  { value: "dissatisfied", label: "Insoddisfatto del servizio" },
  { value: "deceased", label: "Deceduto" },
  { value: "other", label: "Altro" },
];

// Helper to get policy type info (confronto case-insensitive: in archivio una
// polizza puo' avere il tipo scritto "CVT" maiuscolo).
export const getPolicyTypeInfo = (value) => {
  const v = String(value ?? "").trim().toLowerCase();
  return POLICY_TYPES.find(t => t.value === v) || { value, label: value, icon: "📄" };
};
